import type { BaseItemSchema } from "@memorang/types";

/* -----------------Container--------------- */
import StudySessionItemContainer from "../../containers/StudySessionItemContainer";

/* -----------------Child components--------------- */
import Box from "@memorang/ui/components/Box";
import { useLocalSearchParams } from "expo-router";

interface Props {
	items: BaseItemSchema[];
	toggleShowReadMore?: () => void;
}

const SessionListDesktop = ({ items, toggleShowReadMore }: Props) => {
	const localSearchParams = useLocalSearchParams<{
		index: string;
		id: string;
	}>();

	const index = localSearchParams.index
		? Number.parseInt(localSearchParams.index)
		: 0;
	const sessionId = localSearchParams?.id;
	const currentItem = index ? items[index - 1] : items[0];

	return (
		<Box style={{ width: "100%", height: "100%" }}>
			<StudySessionItemContainer
				item={currentItem}
				toggleShowReadMore={toggleShowReadMore}
				sessionId={sessionId ? Number.parseInt(sessionId) : undefined}
			/>
		</Box>
	);
};
export default SessionListDesktop;
